/*! bxs-vue-ui v4.0.1 */
import { N as path } from './es.array.join.js';
import './normalize-component.js';
import './index.js';

var promise = path.Promise;

var promise$1 = promise;

var promise$2 = promise$1;

export { promise$2 as p };
